var _circle, _ellipse, _ellipse2, _circle2, _path, _path2, _ellipse3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmileyDoNotUnderstand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 1024",
    enableBackground: "new 0 0 1024 1024",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_13GSD5F4G6SDRG783DTHX54DFG_",
    cx: 511.9911,
    cy: 512.6978,
    r: 452.5993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3491D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5293,
    style: {
      stopColor: "#328FD3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7199,
    style: {
      stopColor: "#2B8ACF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8557,
    style: {
      stopColor: "#2080C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9649,
    style: {
      stopColor: "#0F72BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    style: {
      stopColor: "#086CBA"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#SVGID_13GSD5F4G6SDRG783DTHX54DFG_)",
    cx: 512,
    cy: 512.7,
    r: 452.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000130617611502508960310000004259588891217633715_",
    cx: 413.4731,
    cy: 406.4099,
    r: 77.1019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#662483"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5511,
    style: {
      stopColor: "#642481"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#5D227B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8905,
    style: {
      stopColor: "#521F70"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    style: {
      stopColor: "#421C62"
    }
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3158 -0.9488 0.9488 0.3158 -102.7199 670.3681)",
    stroke: "url(#SVGID_00000130617611502508960310000004259588891217633715_)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    cx: 413.5,
    cy: 406.4,
    rx: 90.1,
    ry: 58.8
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000002382676939328053950000013494430050940225968_",
    cx: 618.1481,
    cy: 406.4099,
    r: 77.0815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#662483"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5511,
    style: {
      stopColor: "#642481"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#5D227B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8905,
    style: {
      stopColor: "#521F70"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    style: {
      stopColor: "#421C62"
    }
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9974 -7.137749e-02 7.137749e-02 0.9974 -27.4319 45.1585)",
    stroke: "url(#SVGID_00000002382676939328053950000013494430050940225968_)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    cx: 618.1,
    cy: 406.4,
    rx: 58.8,
    ry: 90.1
  }))))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000114785351563428493690000005732349237588646528_",
    cx: 511.9911,
    cy: 512.6978,
    r: 505.8857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3491D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5293,
    style: {
      stopColor: "#328FD3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7199,
    style: {
      stopColor: "#2B8ACF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8557,
    style: {
      stopColor: "#2080C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9649,
    style: {
      stopColor: "#0F72BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    style: {
      stopColor: "#086CBA"
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "url(#SVGID_00000114785351563428493690000005732349237588646528_)",
    strokeWidth: 12.3135,
    strokeMiterlimit: 10,
    cx: 512,
    cy: 512.7,
    r: 499.7
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 28.2897,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    d: "M614.8,205.8c0,0,52.7,100.2,157.9,68.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 28.2897,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    d: "M464.8,191.6c0,0-67.2-99-142,118.9"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(7.352612e-02 -0.9973 0.9973 7.352612e-02 -310.1125 1240.743)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#1D1D1B",
    cx: 512.7,
    cy: 787.3,
    rx: 81.1,
    ry: 50.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1011.7,54.2c0,9.3-1.8,17.1-5.3,23.4c-3.5,6.3-10.8,14.5-22,24.3c-5.5,4.6-10.4,11-14.8,19.1s-6.6,14.9-6.6,20.1 c0,6.5-3.7,9.8-11.1,9.8c-5.8,0-9.3-2-10.7-6c-1.1-2.9-1.9-6.7-2.3-11.4c-0.5-4.7-0.7-8.3-0.7-10.7c0-9.3,1.9-18.4,5.7-27.2 c1.6-3.5,3.2-7.1,4.9-10.7c1.7-3.6,3.1-6.8,4.1-9.6c1-2.8,1.5-5.2,1.5-7.4c0-3.6-1.3-7-4-10.2c-2.6-3.2-7.4-4.8-14.4-4.8 c-5.7,0-11.5,1.3-17.4,3.8h-2.3l13.8-40.7c9.9-3,19.1-4.5,27.8-4.5c11.9,0,21.9,2.1,30,6.2c8.1,4.1,14,9.4,17.9,16 C1009.8,40.2,1011.7,47.1,1011.7,54.2z M984.2,188.5c0,8.6-3.1,16-9.2,22.2c-6.1,6.2-13.5,9.3-22,9.3c-8.6,0-16.1-3.1-22.4-9.2 c-6.3-6.2-9.5-13.6-9.5-22.3c0-8.8,3.2-16.2,9.5-22.3c6.3-6.1,13.8-9.2,22.4-9.2c8.6,0,15.9,3.1,22,9.3 C981.1,172.5,984.2,179.9,984.2,188.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileyDoNotUnderstand);
export default __webpack_public_path__ + "static/media/smiley-do-not-understand.aa202fc1929e776097ee8c5f4578c94c.svg";
export { ForwardRef as ReactComponent };